module.exports = __webpack_public_path__ + "5d2abfe6493f68c6e0d897cb785d6f0a.svg";